// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__23PZE","breadcrumb":"styles_breadcrumb__1W0ON"};